import dynamic from "next/dynamic";
const AffiliateSlider = dynamic(() => import("../../organisms/slider").then((mod) => mod.AffiliateSlider));

export function ParagraphAffiliateSlider({paragraph, ...props}) {
  const places = paragraph?.field_affiliate_slider_place?.filter(item => item?.type !== "unknown");
  return (
    <AffiliateSlider nodes={places}/>
  )
}